module.exports = __webpack_public_path__ + "img/2.09e8937d.jpg";